import { combineReducers } from "redux";
import { VIEW_ERROR, VIEW_LOADING, VIEW_SUCCESS } from "./actions";
import {
  MASTER_TRAYEK_PAGE_ERROR,
  MASTER_TRAYEK_PAGE_LOADING,
  MASTER_TRAYEK_LIST_SUCCESS,
  MASTER_TRAYEK_VIEW_SUCCESS,
  MASTER_TRAYEK_PAGE_SUCCESS,
  MASTER_TRAYEK_VIEW_ERROR,
  MASTER_TRAYEK_ADD_ERROR,
  MASTER_TRAYEK_ADD_LOADING,
  MASTER_TRAYEK_ADD_SUCCESS,
  MASTER_TRAYEK_VIEW_LOADING,
  MASTER_TRAYEK_DELETE_ERROR,
  MASTER_TRAYEK_DELETE_LOADING,
  MASTER_TRAYEK_DELETE_SUCCESS,
  MASTER_TRAYEK_UPDATE_SUCCESS,
  MASTER_TRAYEK_UPDATE_ERROR,
  MASTER_TRAYEK_UPDATE_LOADING,
  MASTER_TRAYEK_DELETE_TRAYEK_ERROR,
  MASTER_TRAYEK_DELETE_TRAYEK_LOADING,
  MASTER_TRAYEK_DELETE_TRAYEK_SUCCESS,
  MASTER_TRAYEK_ADD_TRAYEK_ERROR,
  MASTER_TRAYEK_ADD_TRAYEK_LOADING,
  MASTER_TRAYEK_ADD_TRAYEK_SUCCESS,
  MASTER_TRAYEK_UPDATE_RATES_ERROR,
  MASTER_TRAYEK_UPDATE_RATES_LOADING,
  MASTER_TRAYEK_UPDATE_RATES_SUCCESS,
  MASTER_TRAYEK_LIST_ERROR,
  MASTER_TRAYEK_LIST_LOADING,
} from "./constant";

const initialState = {
  loading: false,
  success: false,
  error: false,
  payload: null,
};

const masterTrayekPageError = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_PAGE_ERROR:
      return action.masterTrayekPageError;
    default:
      return state;
  }
};

const masterTrayekPageLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_PAGE_LOADING:
      return action.masterTrayekPageLoading;
    default:
      return state;
  }
};

const masterTrayekPageSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_PAGE_SUCCESS:
      return action.masterTrayekPageSuccess;
    default:
      return state;
  }
};

const masterTrayeks = (state = [], action) => {
  switch (action.type) {
    case MASTER_TRAYEK_PAGE_SUCCESS:
      return action.masterTrayek;
    case MASTER_TRAYEK_LIST_SUCCESS:
      return action.masterTrayek;
    default:
      return state;
  }
};

const masterTrayek = (state = [], action) => {
  switch (action.type) {
    case MASTER_TRAYEK_VIEW_SUCCESS:
      return action.masterTrayek;
    default:
      return state;
  }
};

const masterTrayekAddError = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_ADD_ERROR:
      return action.masterTrayekAddError;
    default:
      return state;
  }
};

const masterTrayekAddLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_ADD_LOADING:
      return action.masterTrayekAddLoading;
    default:
      return state;
  }
};

const masterTrayekAddSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_ADD_SUCCESS:
      return action.masterTrayekAddSuccess;
    default:
      return state;
  }
};

const masterTrayekViewError = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_VIEW_ERROR:
      return action.masterTrayekViewError;
    default:
      return state;
  }
};

const masterTrayekViewLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_VIEW_LOADING:
      return action.masterTrayekViewLoading;
    default:
      return state;
  }
};

const masterTrayekViewSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_VIEW_SUCCESS:
      return action.masterTrayekViewSuccess;
    default:
      return state;
  }
};

const masterTrayekDeleteError = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_DELETE_ERROR:
      return action.masterTrayekDeleteError;
    default:
      return state;
  }
};

const masterTrayekDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_DELETE_LOADING:
      return action.masterTrayekDeleteLoading;
    default:
      return state;
  }
};

const masterTrayekDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_DELETE_SUCCESS:
      return action.masterTrayekDeleteSuccess;
    default:
      return state;
  }
};

const masterTrayekUpdateError = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_UPDATE_ERROR:
      return action.masterTrayekUpdateError;
    default:
      return state;
  }
};

const masterTrayekUpdateLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_UPDATE_LOADING:
      return action.masterTrayekUpdateLoading;
    default:
      return state;
  }
};

const masterTrayekUpdateSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_UPDATE_SUCCESS:
      return action.masterTrayekUpdateSuccess;
    default:
      return state;
  }
};

const masterTrayekDeleteTrayekError = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_DELETE_TRAYEK_ERROR:
      return action.masterTrayekDeleteTrayekError;
    default:
      return state;
  }
};

const masterTrayekDeleteTrayekLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_DELETE_TRAYEK_LOADING:
      return action.masterTrayekDeleteTrayekLoading;
    default:
      return state;
  }
};

const masterTrayekDeleteTrayekSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_DELETE_TRAYEK_SUCCESS:
      return action.masterTrayekDeleteTrayekSuccess;
    default:
      return state;
  }
};

const masterTrayekAddTrayekError = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_ADD_TRAYEK_ERROR:
      return action.masterTrayekAddTrayekError;
    default:
      return state;
  }
};

const masterTrayekAddTrayekLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_ADD_TRAYEK_LOADING:
      return action.masterTrayekAddTrayekLoading;
    default:
      return state;
  }
};

const masterTrayekAddTrayekSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_ADD_TRAYEK_SUCCESS:
      return action.masterTrayekAddTrayekSuccess;
    default:
      return state;
  }
};

const masterTrayekUpdateRatesError = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_UPDATE_RATES_ERROR:
      return action.masterTrayekUpdateRatesError;
    default:
      return state;
  }
};

const masterTrayekUpdateRatesLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_UPDATE_RATES_LOADING:
      return action.masterTrayekUpdateRatesLoading;
    default:
      return state;
  }
};

const masterTrayekUpdateRatesSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_UPDATE_RATES_SUCCESS:
      return action.masterTrayekUpdateRatesSuccess;
    default:
      return state;
  }
};

const masterTrayekListError = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_LIST_ERROR:
      return action.masterTrayekListError;
    default:
      return state;
  }
};

const masterTrayekListLoading = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_LIST_LOADING:
      return action.masterTrayekListLoading;
    default:
      return state;
  }
};

const masterTrayekListSuccess = (state = false, action) => {
  switch (action.type) {
    case MASTER_TRAYEK_LIST_SUCCESS:
      return action.masterTrayekListSuccess;
    default:
      return state;
  }
};

const getKodeTrayekList = (state = initialState, action) => {
  switch (action.type) {
    case VIEW_LOADING:
      return {
        ...initialState,
        loading: action.loading,
      };
    case VIEW_SUCCESS:
      return {
        ...initialState,
        success: action.success,
        payload: action.payload,
      };
    case VIEW_ERROR:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
};

const masterTrayekReducer = combineReducers({
  masterTrayekPageError,
  masterTrayekPageLoading,
  masterTrayekPageSuccess,

  masterTrayeks,
  masterTrayek,

  masterTrayekAddError,
  masterTrayekAddLoading,
  masterTrayekAddSuccess,

  masterTrayekViewError,
  masterTrayekViewLoading,
  masterTrayekViewSuccess,

  masterTrayekDeleteError,
  masterTrayekDeleteLoading,
  masterTrayekDeleteSuccess,

  masterTrayekUpdateError,
  masterTrayekUpdateLoading,
  masterTrayekUpdateSuccess,

  masterTrayekDeleteTrayekError,
  masterTrayekDeleteTrayekLoading,
  masterTrayekDeleteTrayekSuccess,

  masterTrayekAddTrayekError,
  masterTrayekAddTrayekLoading,
  masterTrayekAddTrayekSuccess,

  masterTrayekUpdateRatesError,
  masterTrayekUpdateRatesLoading,
  masterTrayekUpdateRatesSuccess,

  masterTrayekListError,
  masterTrayekListLoading,
  masterTrayekListSuccess,

  getKodeTrayekList,
});

export default masterTrayekReducer;
